export default (ngModule: ng.IModule) => {
  ngModule
    .directive('conteudoConsulta', function conteudoConsulta(): ng.IDirective {
      return {
        restrict: 'E',
        transclude: true,
        template: require('./conteudo-consulta.html'),
        scope: {
          titulo: '@',
          btnVoltar: '=',
          id: '@containerId'
        },
        controller: ConteudoConsultaController,
        controllerAs: 'vm',
        bindToController: true
      };
    });
};

/** @ngInject */
function ConteudoConsultaController($mdMedia, $mdSidenav, Usuario, Navegacao) {
  this.mdMedia = $mdMedia;
  this.toggle = () => $mdSidenav('left').toggle();
  this.voltar = Navegacao.voltar;
  this.usuario = Usuario.obterUsuario().nm_usuario;
}



/** WEBPACK FOOTER **
 ** ./pages/consulta/common/components/conteudo/conteudo-consulta.directive.ts
 **/